import Box from "@mui/material/Box";
import { useCallback, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import AlertMessages from "common/Alert/AlertMessages";
import { useTranslation } from "react-i18next";
import Loader from "layout/Loader";
import BackendPaginationTable from "common/Table/TableWithPagination";
import { useNavigate, useParams } from "react-router-dom";
import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { useGetAccountLedgerByIDService } from "subModule/src/services/bankaccount/useBankAccount";
import { Button, CircularProgress, Grid } from "@mui/material";
import { themes } from "theme/themes";
import { brandingInfo } from "features/server/brandingSlice";
import { useSelector } from "react-redux";
import { CommonProfileService } from "subModule/src/core/services";
import { selectUserInfo } from "features/user/userSlice";

export default function AccountLedgerListing() {
  const navigate = useNavigate();
  const params = useParams();
  const branding = useSelector(brandingInfo);
  const themeColors =
    branding?.attributes?.themeId === 100
      ? branding?.attributes?.customTheme
      : (themes as any)[branding?.attributes?.themeId || 3];
  const loggedInUserCurrency = useSelector(selectUserInfo)?.business?.currency;
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(20);
  const [downloading, setDownloading] = useState<boolean>(false);
  const {
    data: tableData,
    isFetching,
    refetch,
  } = useGetAccountLedgerByIDService(Number(params?.id), {
    pageNumber: pageNo,
    size: pageSize,
  });
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const fetchData = useCallback(() => {
    refetch().then((res: any) => {
      if (!res?.data?.pages[0]?.success)
        enqueueSnackbar(
          <AlertMessages
            text={res?.data?.pages[0]?.message || "Something went wrong"}
          />,
          { variant: "error" },
        );
    });
  }, []);
  useEffect(() => {
    fetchData();
  }, [pageNo, pageSize]);
  const handleChangePage = (pageNo: number) => {
    setPageNo(pageNo + 1);
  };
  const handleChangeRows = (pageSize: number) => {
    setPageSize(pageSize);
    setPageNo(1);
  };
  const DownloadLedgers = () => {
    CommonProfileService.exportEntityWithParams(
      {},
      `bankaccounts/export/excel/ledger/${params?.id}`,
    )
      .then((res: Blob) => {
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Ledgers-${params?.name?.replace(/\s+/g, "")}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
        enqueueSnackbar(<AlertMessages text={t("downloadedSuccessfully")} />, {
          variant: "success",
        });
      })
      .catch((err) => {
        console.error("===", err);
        enqueueSnackbar(<AlertMessages statusCode={0} />, { variant: "error" });
      })
      .finally(() => {
        setDownloading(false);
      });
  };
  return (
    <Box>
      <ComponentHeaderTwo
        showBtn={true}
        showSaveBtn={false}
        onClick={() => navigate(-1)}
        heading={t("accountLedgers") + " " + ` (${params?.name || ""})`}
        icon={
          <ReceiptLongIcon
            sx={{
              fill: "#000",
              width: "30px",
              height: "30px",
              marginTop: "3px",
            }}
          />
        }
        btnText={"back"}
        btnType={"back"}
        showCreateBtn={false}
      />
      {isFetching ? (
        <Loader />
      ) : (
        <BackendPaginationTable
          columns={[
            {
              id: "transactionType",
              label: "transactionType",
              numeric: false,
            },
            { id: "referenceNo", label: "referenceNo", numeric: false },
            { id: "creditDebit", label: "Credit/Debit", numeric: false },
            { id: "balance", label: "balance", numeric: false },
            {
              id: "transactionDate",
              label: "transactionDate",
              numeric: false,
            },
          ]}
          data={tableData?.pages[0]?.data?.content || []}
          pageNo={pageNo}
          pageSize={pageSize}
          tableData={tableData?.pages[0]?.data || {}}
          showCheckbox={false}
          showActions={true}
          enableSorting={true}
          showHeader={true}
          showSearch={true}
          showFilter={true}
          showCreateButton={true}
          actions={[]}
          handleChangePage={handleChangePage}
          handleChangeRows={handleChangeRows}
          rowClick={true}
          showRowView={() => {}}
          loadingSearch={false}
          currency={loggedInUserCurrency}
          headerComponent={
            <>
              <Grid item className="block ">
                <Button
                  id="import-button"
                  variant="contained"
                  disableElevation
                  onClick={() => {
                    setDownloading(true);
                    DownloadLedgers();
                  }}
                  // endIcon={<KeyboardArrowDownIcon />}
                  className={`bg-white font-Saira font-[600] text-[13px]  cursor-pointer rounded-[6px] `}
                  sx={{
                    outline: "2px solid",
                    color: themeColors?.secondary,
                    borderColor: themeColors?.secondary,
                  }}
                  disabled={downloading}
                >
                  {downloading ? (
                    <CircularProgress
                      sx={{
                        color: themeColors?.secondary,
                        marginRight: "8px",
                      }}
                      size={16}
                    />
                  ) : (
                    ""
                  )}
                  {t("export")}
                </Button>
              </Grid>
            </>
          }
        />
      )}
    </Box>
  );
}
